export enum TMailerType {
    Message = 'message',
    Report = 'report'
}

export type TMailer = {
    type: TMailerType;
    mess: string;
}
